import(/* webpackMode: "eager" */ "/app/src/app/company/careers/php-developer/page.tsx");
